import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { AdvanceDirectives } from '~/features/demographics/advance-directives/AdvanceDirectives';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientAdvanceDirectivesRoute() {
	const { stayId } = useChart();
	return (
		<Section header={<SectionTitle title="Advance Directives" />}>
			<AdvanceDirectives stayId={stayId} />
		</Section>
	);
}
